import { render, staticRenderFns } from "./Novel_Classification.vue?vue&type=template&id=1594c330&scoped=true&"
import script from "./Novel_Classification.vue?vue&type=script&lang=js&"
export * from "./Novel_Classification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1594c330",
  null
  
)

export default component.exports